import { ValueOf } from '@/types/util';

export const walletUserLockStatus = {
  AVAILABLE: 'ロックなし',
  LOCKED: 'ログインロック中',
} as const;

export type WalletUserLockStatusKey = keyof typeof walletUserLockStatus;
export type WalletUserLockStatusValue = ValueOf<typeof walletUserLockStatus>;

export const WalletUserLockStatusKeys = Object.keys(walletUserLockStatus) as WalletUserLockStatusKey[];

/** v-select用items */
export const WalletUserLockStatusItems = WalletUserLockStatusKeys
  .map((key) => ({
    title: walletUserLockStatus[key],
    value: key,
  }));
